module.exports = __webpack_public_path__ + "static/img/Blayke-Brailey.f4f7792.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Blayke-Brailey.jpg
// module id = IDp2
// module chunks = 0